import { AxiosArgs, ThenArgs, Scenario, Modifiers, ProjectionVariant } from 'src/api/types';
import axios, { AxiosResponse } from 'axios';
import { QueryKey } from 'react-query';
import { encodeBody, encodeQueryParams } from 'src/api/client';

type GetScenario = (
  key: QueryKey,
  parameters: {
    scenarioId: string | number;
    version?: string;
    variant?: ProjectionVariant;
  },
) => Promise<AxiosArgs<ThenArgs<AxiosResponse<Scenario>>>>;

export const getScenario: GetScenario = (_, { scenarioId, version, variant }) => {
  const path = `/api/public/api/scenarios/${scenarioId}${encodeQueryParams({ version, variant })}`;
  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data.data);
};
// ------------------------------------------------------------

interface ChartData {
  chart: { x: number; y: number }[];
}

interface ChartResponse {
  data: {
    completeChart: ChartData;
    liveChart: ChartData;
  };
}

export type CalcModChartParameters = { scenario_id: string; modifiers: Modifiers };
type CalcModChart = (parameters: CalcModChartParameters) => Promise<ChartResponse>;

export const calcModChart: CalcModChart = (parameters) => {
  const path = `/api/public/api/scenarios/modified-chart`;
  return axios({
    method: 'POST',
    url: path,
    data: encodeBody(parameters),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data);
};
